import { http } from '@/http'
import { Util } from "wize-admin"

export default {
  list(data, params) {
    return http.post('/api/v1/business/list', data, { params })
  },
  save(data) {
    const formData = Util.getFormData(data);
    return http.post('/api/v1/business', formData, { headers: { "Content-Type": "multipart/form-data" }, })
  },
  get(id) {
    return http.get(`/api/v1/business/${id}`)
  },
  respond(data, params) {
    return http.put(`/api/v1/business`, data, { params })
  },
  update(id, data) {
    const formData = Util.getFormData(data);
    return http.put(`/api/v1/business/${id}/general`, formData)
  },
  downloadList(params) {
    return http.post('/api/v1/business/xlsx', {}, {
      responseType: 'blob',
      params
    })
  },
  toggleStatus(id, status) {
    return http.put(`/api/v1/business/${id}/status`, null, {
      params: {
        status
      },
    });
  },
  delete(id) {
    return http.delete(`/api/v1/business/${id}`);
  }
}
